<template>
    <modal
      :show-modal="showModal"
      @close-modal="closeModal"
      width="40"
    >
      <div class="plain-box">
        <button @click="$emit('triggerfeedback')" class="absolute transform rotate-90 bg-primary-yellow rounded click-box">Leave us a feedback</button>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: ["showModal"],
    data(){
      return {
        reference: ""
      }
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
    },
  };
  </script>
  
  <style> 
  .plain-box{
    width: 100%;
    height: 400px;
    position: relative;
  }
  .click-box{
    width: 200px;
    left: calc(100% - 100px);
    top: calc(100% - 100px);
    text-align: center;
    height: 30px;
  }
  .entity-name {
    background: #dae8f6;
    padding: 0.5em;
    text-align: center;
  }
  </style>